import { A } from "@solidjs/router";

export const Footer = () => {
	return (
		<footer class="bg-primary mt-6 py-6 fixed bottom-0 w-full text-center text-sm">
			<div class="main-container text-xl mb-2">
				 <A href="/privacy-policy" class="hover:underline">Privacy Policy</A> | <A href="/terms-and-conditions" class="hover:underline">Terms and Conditions</A>	
			</div>

			<div class="main-container">
				&copy; {new Date().getFullYear()} | Home Energy and Data Services Ltd | Development by Dynamic Array Ltd | v{__APP_VERSION__} | All Rights Reserved
			</div>
		</footer> );
} 